import { combineReducers } from '@reduxjs/toolkit';
import permissionSlice from './Permission';
import topUpOrderDetailSlice from './TopUpOrderDetail';
import withdrawOrderDetailSlice from './WithdrawOrderDetail';
import accountTypeSlice from './accountType';
import counterSlice from './counter'; // 可以引入各种 reducer
import exportDataSlice from './exportData';
import noFeeSetMerchantSlice from './noFeeSetMerchant';
import pageSlice from './page';
import selectMerchantSlice from './selectMerchant';
import settleAccountDetialSlice from './settleAccountDetail';
import settleOrderSlice from './settleOrder';
import settleOrderDetailSlice from './settleOrderDetail';
import stepCurrentSlice from './stepCurrent';
import verifyInfoSlice from './verifyInfo';
import verifyStatusSlice from './verifyStatus';

const rootReducers = combineReducers({
    counter: counterSlice, // 这里通过 MAP 形式，自定义不同 reducer 的“命名空间”
    verifyInfo: verifyInfoSlice,
    accountType: accountTypeSlice,
    page: pageSlice,
    settleOrder: settleOrderSlice,
    settleOrderDetail: settleOrderDetailSlice,
    exportData: exportDataSlice,
    noFeeSetMerchant: noFeeSetMerchantSlice,
    stepCurrent: stepCurrentSlice,
    topUpOrderDetail: topUpOrderDetailSlice,
    settleAccountDetail: settleAccountDetialSlice,
    verifyStatus: verifyStatusSlice,
    permission: permissionSlice,
    withdrawOrderDetail: withdrawOrderDetailSlice,
    selectMerchant: selectMerchantSlice,
});

// 默认导出，给 configureStore 消费
export default rootReducers;
